import { useContext } from "react";
import { CommonPropsContext } from "../contexts/CommonPropsContext";
import Customer from "./Customer";

const CustomerIndex = () => {
  const { dbConnections, loadingContext } = useContext(CommonPropsContext);

  return (
    <>
      {!loadingContext ? (
        <>
          {dbConnections.length > 0 &&
            // dbConnections.map((connection_key, index) => (
              <div>
                <Customer connection_key={dbConnections[0]} />
              </div>
            // ))
            }
        </>
      ) : (
        <div id="loader"></div>
      )}
    </>
  );
};

export default CustomerIndex;
